import { dashboard } from './dashboard';
import { password } from './password';
import shared from './shared';
import country from './shared/country';
import { user } from './user';

export default {
  ...shared,
  ...country,
  'i-dashboard': dashboard,
  'i-password': password,
  'i-user': user
};
